import { Injectable, inject } from '@angular/core';
import { FilingFormStateService, FilingFormState } from './filing-form-state.service';
import { computeRowStatus, MappingStatus, RowStatusInput } from './mapping-status';

/**
 * Single authority for a row's Mapping Status across every XBRL sheet.
 * "Edited vs Validated" derives from the last-submission baseline (originalState);
 * the Validated* extracted-sum reference derives from the immutable N8N snapshot.
 * No per-sheet markers, no persistence to desync.
 */
@Injectable({ providedIn: 'root' })
export class MappingStatusService {
  private state = inject(FilingFormStateService);

  /** Last-submission baseline for a sheet (the moving comparison anchor for "Edited"). */
  getLastSubmissionValues(sheetKey: keyof FilingFormState): Record<string, unknown> {
    return this.state.getOriginalSheetData(sheetKey) ?? {};
  }

  /** Immutable N8N snapshot baseline for a sheet (the extracted-sum reference for Validated*). */
  getSnapshotValues(sheetKey: keyof FilingFormState): Record<string, unknown> {
    return this.state.getSnapshotSheetData(sheetKey) ?? {};
  }

  /** Pure decision — see mapping-status.ts. Re-exposed for ergonomic injection. */
  computeRowStatus(input: RowStatusInput): MappingStatus {
    return computeRowStatus(input);
  }
}
